import React, { useState } from 'react';
import { Box, Paper, Tab, Tabs, Typography } from '@material-ui/core';

import { CreateEmployeeBox } from 'components/infoTech/components/createEmployeeBox';
import { ViewEmployeeBox } from 'components/infoTech/components/viewEmployeeBox';
import { TabPanel } from 'shared';

function EmployeeBox({ baseUrl }) {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab label="View employee box" value="0" />
                <Tab label="Create employee box" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewEmployeeBox />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <CreateEmployeeBox />
            </TabPanel>
        </Paper>
    );
}

export { EmployeeBox };
